module.exports = __webpack_public_path__ + "static/assets/12d5ecb2f713250a980ccbdc9642767d.svg";